// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"341":"0fa00767","669":"b2ca740f","744":"810e66bd"}[chunkId] + ".chunk.css";
};